import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import css from './ContractDetails.module.css';
import CDGeneral from './CDGeneral';

import * as contractServices from '../../../../services/contractService.js';
import Overlay from '../../_common/elements/Overlay.js';
import AddContract from './AddContract.js';
import ContractRequests from './ContractRequests.js';
import ContractInvoices from './ContractInvoices.js';

function ContractDetails() {
    const { contractId } = useParams();
    const [contractDetails, setContractDetails] = useState([{ contractId }]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        contractServices
            .getById(contractId)
            .then((res) => {
                setContractDetails(res.data[0]);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [contractId, showModal]);

    const onAdd = (e, newData) => {
        e.preventDefault();
        console.log(newData);
        newData._id = newData.contractId;

        contractServices
            .edit(newData)
            .then((res) => {
                console.log(res);
                toggleModal();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const toggleModal = () => setShowModal(!showModal);

    return (
        <div>
            <h1 className={css.h1}>{`(${contractDetails?.customerNameShort}) ${contractDetails?.contractTitle}`}</h1>
            <CDGeneral data={contractDetails} toggleModal={toggleModal} />
            <ContractRequests contractId={contractDetails.contractId} />
            <ContractInvoices contractId={contractDetails.contractId} />
            {showModal && (
                <Overlay>
                    <AddContract onAdd={onAdd} onClose={toggleModal} func={'Edit'} data={contractDetails} />
                </Overlay>
            )}
        </div>
    );
}

export default ContractDetails;
